import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, share, switchMap, withLatestFrom } from 'rxjs/operators';
import { dashboardActions } from '..';
import { DashboardService } from '../../services/dashboard/dashboard.service';
import { IDashboardState, IState } from '../states';

@Injectable()
export class DashboardEffects {
  constructor(
    private _actions$: Actions,
    private _dashboardStore: Store<IState>,
    private _dashboardService: DashboardService,
  ) {}

  loadDashboardData$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType(dashboardActions.loadDashboardData),
        share(),
        withLatestFrom(this._dashboardStore),
        switchMap(([action, store]) => {
          this._dashboardStore.dispatch(dashboardActions.rangeActions.setIsLoading({ isLoading: true }));

          return Promise.all([
            this._dashboardService
              .getDashboardData(action.shopId, {
                startDateValue: store.dashboard.range.startDateValue,
                endDateValue: store.dashboard.range.endDateValue,
              })
              .pipe(
                map((dashboardData: IDashboardState) =>
                  this._dashboardStore.dispatch(dashboardActions.loadDashboardDataSuccess(dashboardData)),
                ),
                catchError(() => of(dashboardActions.loadDashboardDataFailure())),
              ),
            this._dashboardService
              .getDashboardDataV2(action.shopId, {
                startDateValue: store.dashboard.range.startDateValue,
                endDateValue: store.dashboard.range.endDateValue,
              })
              .pipe(
                map((dashboardData: IDashboardState) =>
                  this._dashboardStore.dispatch(dashboardActions.loadDashboardDataSuccess(dashboardData)),
                ),
                catchError(() => of(dashboardActions.loadDashboardDataFailure())),
              ),
          ]);
        }),
      ),
    {
      dispatch: false,
    },
  );
}
